import React from 'react';
import Input from '../../../components/ui/Input';
import { cn } from '../../../utils/cn';

const RequestFormFields = ({ formData, onChange, errors = {} }) => {
  return (
    <div className="space-y-6">
      {/* User Name */}
      <Input
        label="User Name"
        type="text"
        value={formData.user_name}
        onChange={(e) => onChange('user_name', e.target.value)}
        placeholder="Enter your name"
        required
        error={errors.user_name}
      />

      {/* User Site & Plant */}
      <Input
        label="User Site & Plant"
        type="text"
        value={formData.user_site_plant}
        onChange={(e) => onChange('user_site_plant', e.target.value)}
        placeholder="e.g., Mumbai Plant - A, Delhi Office"
        required
        error={errors.user_site_plant}
        description="Enter the site or plant location"
      />

      {/* Required Vendor Name */}
      <Input
        label="Required Vendor Name"
        type="text"
        value={formData.required_vendor_name}
        onChange={(e) => onChange('required_vendor_name', e.target.value)}
        placeholder="Enter vendor/supplier name"
        required
        error={errors.required_vendor_name}
      />

      {/* Vendor Contact */}
      <Input
        label="Vendor Contact"
        type="text"
        value={formData.vendor_contact}
        onChange={(e) => onChange('vendor_contact', e.target.value)}
        placeholder="Contact person name and phone"
        required
        error={errors.vendor_contact}
        description="Contact person name and phone number"
      />

      {/* Vendor Email */}
      <Input
        label="Vendor Email"
        type="email"
        value={formData.vendor_email}
        onChange={(e) => onChange('vendor_email', e.target.value)}
        placeholder="vendor@example.com"
        required
        error={errors.vendor_email}
      />

      {/* Reason for Creating New Vendor Code */}
      <div className="space-y-2">
        <label
          htmlFor="reason_for_new_vendor"
          className={cn(
            "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
            errors.reason_for_new_vendor ? "text-destructive" : "text-foreground"
          )}
        >
          Reason for Creating New Vendor Code <span className="text-destructive ml-1">*</span>
        </label>
        <textarea
          id="reason_for_new_vendor"
          value={formData.reason_for_new_vendor}
          onChange={(e) => onChange('reason_for_new_vendor', e.target.value)}
          rows={4}
          className={cn(
            "flex w-full rounded-md border border-border bg-white text-foreground px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 resize-y",
            errors.reason_for_new_vendor && "border-destructive focus-visible:ring-destructive"
          )}
          placeholder="Please provide a detailed reason for requiring this new vendor..."
        />
        {errors.reason_for_new_vendor && (
          <p className="text-sm text-destructive">
            {errors.reason_for_new_vendor}
          </p>
        )}
      </div>

      {/* Requested By */}
      <Input
        label="Requested By"
        type="text"
        value={formData.requested_by}
        onChange={(e) => onChange('requested_by', e.target.value)}
        placeholder="Your name or department"
        required
        error={errors.requested_by}
      />
    </div>
  );
};

export default RequestFormFields;

